<script setup lang="ts">
import { ref } from 'vue'

import IconVerified from '@lahaus-roomie/roomie/src/assets/icons/verified.svg'

const { t, tm, rt } = useI18n()
const items: {title: string; description: string, imageUrl: string}[] = tm('items')

const selectedItemIdx = ref(0)
</script>

<script lang="ts">
export default {
  name: 'WhoWeAreLaHausHelpsYou'
}
</script>

<template>
  <div class="w-full bg-pine-600 text-white py-64 px-24 lg:py-90 lg:px-90">
    <div class="max-w-screen-lg mx-auto">
      <div class="flex items-center gap-16">
        <div class="flex flex-row">
          <svg
            width="54"
            height="31"
            viewBox="0 0 54 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">

            <path
              id="Vector"
              d="M0.547301 1.02214C0.314742 0.688268 0.553641 0.230718 0.96052 0.230716L42.5398 0.230477C42.7036 0.230477 42.8572 0.310149 42.9516 0.44407L53.1053 14.8593C53.2278 15.0333 53.2278 15.2654 53.1053 15.4393L42.9515 29.8545C42.8572 29.9885 42.7036 30.0681 42.5398 30.0681L0.960529 30.0683C0.553646 30.0684 0.314747 29.6108 0.547306 29.2769L10.1873 15.4374C10.3078 15.2644 10.3078 15.0347 10.1873 14.8617L0.547301 1.02214Z"
              fill="#E6FA41" />
          </svg>

          <svg
            class="-ml-8"
            width="23"
            height="31"
            viewBox="0 0 23 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">

            <path
              id="Vector"
              d="M0.803654 1.02213C0.571095 0.688257 0.809994 0.230709 1.21688 0.230707L12.2342 0.230645C12.398 0.230643 12.5516 0.310315 12.6459 0.444236L22.7996 14.8595C22.9221 15.0334 22.9221 15.2655 22.7996 15.4394L12.6459 29.8547C12.5516 29.9886 12.398 30.0683 12.2342 30.0683L1.21689 30.0684C0.810005 30.0684 0.571102 29.6108 0.803661 29.2769L10.4436 15.4374C10.5641 15.2644 10.5641 15.0347 10.4436 14.8617L0.803654 1.02213Z"
              fill="white" />
          </svg>
        </div>

        <h2 class="display-6 font-bold lg:display-5">
          {{ t('title.1') }} <span class="text-lime-600">{{ t('title.2') }}</span>
        </h2>
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-2 gap-100 mt-48 lg:mt-56">
        <div class="flex flex-col gap-4 justify-between">
          <div
            v-for="(item, index) in items"
            :key="index"
            :class="index === items.length - 1 ? '' : 'lg:h-96'"
            class="flex flex-row gap-12 cursor-pointer"
            @mouseenter="selectedItemIdx = index">
            <div class="flex flex-col items-center gap-4 min-h-full">
              <div class="w-24 h-24 lg:w-48 lg:h-48">
                <IconVerified
                  :class="{'lg:opacity-30': index !== selectedItemIdx}"
                  class="w-24 h-24 lg:w-48 lg:h-48 fill-spring-600" />
              </div>

              <div
                v-if="index !== items.length - 1"
                class="w-2 lg:w-4 h-full bg-spring-600 opacity-30" />
            </div>

            <div>
              <div class="flex items-center lg:h-48">
                <h3
                  :class="{'lg:text-gray2-400 lg:opacity-30': index !== selectedItemIdx}"
                  class="hl-3-sb lg:hl-2-sb">
                  {{ rt(item.title) }}
                </h3>
              </div>

              <p
                :class="index === items.length - 1 ? '' : 'mb-60'"
                class="lg:hidden body-2-m mt-12">
                {{ rt(item.description) }}
              </p>
            </div>
          </div>
        </div>

        <div
          class="h-[500px] hidden lg:flex flex-col gap-4 relative">
          <img
            :src="rt(items[selectedItemIdx].imageUrl)"
            :alt="rt(items[selectedItemIdx].title)"
            class="w-full h-full object-cover rounded-24">

          <div class="absolute left-[24px] bottom-[24px] bg-white rounded-lg w-[388px]">
            <p class="hl-3-sb text-pine-600 px-24 py-20">
              {{ rt(items[selectedItemIdx].description) }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<i18n src="./i18n.json" lang="json"></i18n>
